
export default {
  name: 'RaiseCapitalFreezone',
}
